import { RenderComponentOrLoading, STATUS_ENUM } from '@innovyze/stylovyze';
import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useIntegrationById } from '@Selectors/integration.selector';
import {
	IntegrationType,
	VaparSettingsFormValues,
} from '../../types/integration.types';
import { getSingleIntegrationById } from '../actions/integrations.actions';
import VaparSettingsForm from './VaparSettingsForm';
import VaparSettings from './VaparSettings';

export default function IntegrationEditVapar() {
	const dispatch = useDispatch();

	const { editId } = useParams<{ editId: string }>();
	const { status, integration } = useIntegrationById();

	const initialValues = useMemo(() => {
		let VaparSettings: VaparSettingsFormValues = {
			_id: integration?._id,
			name: integration?.name,
			description: integration?.description,
			enabledAiDefault: integration?.enabledAiDefault ?? false,
			integrationInfo: {
				isEnabled: integration?.isEnabled ?? false,
				integrationType: IntegrationType.Vapar,
				lastUpdatedData:
					integration?.lastModifiedTimestamp?.toString() ?? '',
				toBeEnabled: integration?.isEnabled ?? false,
				videosProcessed: integration?.videosProcessed,
			},
		};
		if (integration?.username) {
			VaparSettings = {
				...VaparSettings,
				integrationInfo: {
					integrationType: IntegrationType.Vapar,
					isEnabled: integration?.isEnabled ?? false,
					lastUpdatedData:
						integration?.lastModifiedTimestamp?.toString() ?? '',
					authenticated: true,
					username: integration?.username,
					isValid: integration?.isValid,
					toBeEnabled: integration?.isEnabled,
					connectedLayerCount: integration?.connectedLayerCount,
					lastImportTimestamp:
						integration?.lastImportTimestamp?.toString() ?? '',
					videosProcessed: integration?.videosProcessed,
				},
				integrationTokenInfo: {
					clientId: integration?.clientId ?? '',
					portal: integration?.portal ?? '',
					organizationId: integration?.organizationId ?? '',
					type: integration?.type,
				},
			};
		}
		return VaparSettings;
	}, [status, integration]);

	useEffect(() => {
		dispatch(getSingleIntegrationById(editId));
	}, [editId, dispatch]);

	return (
		<RenderComponentOrLoading loading={status != STATUS_ENUM.SUCCESS}>
			{status === STATUS_ENUM.SUCCESS && initialValues && (
				<VaparSettingsForm initialValues={initialValues}>
					<VaparSettings />
				</VaparSettingsForm>
			)}
		</RenderComponentOrLoading>
	);
}
